var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferredActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.843.825H1.597L0 5.47h1.03v8.28l2.12-.91V2.791L3.843.825zM17.008 3.392H25.9l.614-1.643h-9.11l.223-.924h-2.244L14.5 4.637h2.206l.302-1.245zM14.304 13.373h2.254l3.041-5.172h-2.245l-3.05 5.172z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.943 4.883l.615-1.643H7.543l.32-2.583h-2.12l-.32 2.583H3.465v1.643h1.751l-1.057 8.49h2.128l1.052-8.49h4.603zM26.104 7.614l.614-1.642H14.173v1.642h7.098v3.82s-.06 1.762 1.644 1.94h2.875l.831-1.623h-2.498s-.89.04-.89-.812V7.614h2.871z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.556 10.94V5.47h-1.96v5.963s-.06 1.762 1.643 1.94h1.803l.831-1.623h-1.426c0 .001-.89.04-.89-.81zM11.363 2.283a.93.93 0 10-1.718-.711.93.93 0 001.718.711z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.643 0L18.74 4.667l1.106.29-1.623 2.666 5.295-3.814h-2.311L24.164 0h-3.52z",
    fill: "#FEB34E"
  })));
}
export default __webpack_public_path__ + "static/preferred-active.2c534341.svg";
export { SvgPreferredActive as ReactComponent };